/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Disable_SuccessInputs */



/**
* | output |
* | --- |
* | "Every member can see everyone's chats in this project again." |
*
* @param {Project_Private_Chats_Disable_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_disable_success = /** @type {((inputs?: Project_Private_Chats_Disable_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Disable_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Mitglieder sehen wieder die Chats aller Mitglieder in diesem Projekt.")
	return /** @type {LocalizedString} */ ("Every member can see everyone's chats in this project again.")
});